<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.automatic_fouls', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="w-full flex space-x-4 justify-end" v-if="meta.can.create">
            <AppButton :href="meta.links.create" element="inertia-link">
                {{ $t('messages.create') }}
            </AppButton>
        </div>

        <EmptyState picture v-if="foulConfigs.length === 0">
            <template v-slot:picture />
        </EmptyState>

        <div v-for="foulConfig in foulConfigs" class="mt-5" :key="foulConfig.id">
            <div class="flex justify-between">
                <div>{{ foulConfig.grade_level_names }}</div>
                <div class="flex justify-end space-x-1">
                    <InertiaSquareLinkButton action="edit" :href="foulConfig.links.edit" />
                    <InertiaSquareDeleteButton :href="foulConfig.links.delete" v-if="foulConfig.links.delete" />
                </div>
            </div>

            <AppWell class="mt-5">
                <div class="flex flex-col mt-5">
                    <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                        <div
                            class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                        >
                            <table class="min-w-full divide-y divide-gray-200">
                                <thead>
                                    <tr>
                                        <th
                                            class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            {{ $tc('messages.triggers', 1) }}
                                        </th>
                                        <th
                                            class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            {{ $t('messages.automatic_generated_foul') }}
                                        </th>
                                        <th
                                            class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            {{ $t('messages.type') }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(rule, index) in foulConfig.rules"
                                        :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                        :key="rule.id"
                                    >
                                        <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                            {{ rule.trigger }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                            {{ rule.generated_foul }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                            {{ rule.types_display }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </AppWell>
        </div>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import InertiaSquareDeleteButton from '@/components/InertiaSquareDeleteButton.vue';
import AppButton from '@/components/AppButton.vue';
import AppWell from '@/Shared/AppWell.vue';
import EmptyState from '@/components/EmptyState.vue';

export default {
    components: {
        PanelPage,
        InertiaSquareLinkButton,
        InertiaSquareDeleteButton,
        AppButton,
        AppWell,
        EmptyState,
    },
    layout: AdminLayout,
    name: 'Index',
    props: ['meta', 'foulConfigs', 'filters'],
    data() {
        return {};
    },
};
</script>
